var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00054 7.32996C6.44346 7.32996 5.99023 7.78318 5.99023 8.34026C5.99023 8.74248 6.22653 9.09046 6.56755 9.25288V10.7992H7.43353V9.25286C7.77456 9.0904 8.01085 8.74245 8.01085 8.34023C8.01085 7.78318 7.55763 7.32996 7.00054 7.32996Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95963 5.01818V2.95876C9.95963 1.32729 8.63234 0 7.00087 0C5.36939 0 4.0421 1.32729 4.0421 2.95876V5.01818C2.81709 5.92616 2.02148 7.38216 2.02148 9.02062C2.02148 11.7663 4.25522 14 7.00087 14C9.74651 14 11.9802 11.7663 11.9802 9.02062C11.9802 7.38216 11.1846 5.92616 9.95963 5.01818ZM4.90808 2.95876C4.90808 1.80479 5.84689 0.865979 7.00087 0.865979C8.15484 0.865979 9.09365 1.80479 9.09365 2.95876V4.50304C8.45704 4.20696 7.74798 4.04124 7.00087 4.04124C6.25376 4.04124 5.54469 4.20696 4.90808 4.50306V2.95876ZM7.00087 13.134C4.73272 13.134 2.88746 11.2888 2.88746 9.02062C2.88746 6.75247 4.73272 4.90722 7.00087 4.90722C9.26901 4.90722 11.1143 6.75247 11.1143 9.02062C11.1143 11.2888 9.26901 13.134 7.00087 13.134Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.db41193a.svg";
export { ForwardRef as ReactComponent };